import React from 'react';
import { MenuItem, withStyles } from '@material-ui/core';
import colors from '../../libs/colors';
import images from '../../assets';
export const StyledMenu = ({ children, ...props }) => {
  return (
    <div
      {...props}
      style={{
        position: 'absolute',
        left: 0,
        top: 40,
        backgroundColor: 'white',
        border: '1px solid #eeeeee',
        width: 'max-content',
        zIndex: 99,
      }}
    >
      <div style={{ margin: 0, zIndex: 99 }}>{children}</div>
    </div>
  );
};

const CusMenuItem = withStyles({
  root: {
    // width: 302
  },
})(MenuItem);

export const StyledMenuItem = ({ title, active = false,logout=false, ...props }) => {
  return (

    <CusMenuItem {...props} style={logout ? (active ? activeLogoutMenu : normalLogoutMenu) : (active ? activeMenu : normalMenu)} >
      {title} 
      {logout?
      (<img alt="" src={images.logout} style={{ width: 30, height: 'auto', marginRight: 0 , display:'flex',float:'right'}} />):
    <></>}
    </CusMenuItem>

  );
};

const activeMenu = {
  fontFamily: 'NSCJKrR',
  color: colors.active,
  fontSize: 18,
  lineHeight: '50px',
};

const normalMenu = {
  fontFamily: 'NSCJKrR',
  color: 'black',
  fontSize: 18,
  lineHeight: '50px',
};

const activeLogoutMenu = {
  fontFamily: 'NSCJKrR',
  fontSize: 18,
  lineHeight: '50px',
  color :'#6A6A6A'
};

const normalLogoutMenu = {
  fontFamily: 'NSCJKrR',
  fontSize: 18,
  lineHeight: '50px',
  color:'#6A6A6A'
};
